import React from 'react';
import { useModalsContext, useStoreConfigContext } from '/src/providers';
import { Modal, Errors, H2, Form } from '/src/components';

const Error = ({ errors }) => {
    const { translate } = useStoreConfigContext();
    const { hideModal } = useModalsContext();

    return (
        <Modal toggle={hideModal}>
            <H2>{translate('Error')}</H2>
            <Errors errors={errors} translate={translate} />
            <Form.Column mt>
                <Form.Button onClick={hideModal}>
                    {translate('Close')}
                </Form.Button>
            </Form.Column>
        </Modal>
    );
};

export default Error;
